var React = require('react');

function IconBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.217503 8.52854L6.96 15.2803C7.2525 15.5732 7.725 15.5732 8.0175 15.2803C8.31 14.9874 8.31 14.5143 8.0175 14.2214L2.5575 8.75385L17.25 8.75385C17.6625 8.75385 18 8.41588 18 8.00282C18 7.58975 17.6625 7.25178 17.25 7.25178L2.5575 7.25178L8.0175 1.77675C8.31 1.48385 8.31 1.0107 8.0175 0.717798C7.8675 0.567592 7.68 0.5 7.485 0.5C7.29 0.5 7.1025 0.575102 6.9525 0.717798L0.210002 7.46958C0.0750034 7.60477 2.58116e-06 7.79253 2.56343e-06 7.9953C2.5457e-06 8.19808 0.0750033 8.38584 0.217503 8.52854Z"}));
}

IconBack.defaultProps = {"viewBox":"0 0 18 16","fill":"none"};

module.exports = IconBack;

IconBack.default = IconBack;
